export default __webpack_public_path__ + "static/media/Banner-Promoção-Encerrada.0d5b10ec.jpg";